 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT01_COVER from '@/components/text/01_cover'
 import TEXT02_HALFTITLEPAGE from '@/components/text/02_halftitlepage'
 import TEXT03_TITLEPAGE from '@/components/text/03_titlepage'
 import TEXT04_COPYRIGHTPAGE from '@/components/text/04_copyrightpage'
 import TEXT05_DEDICATION from '@/components/text/05_dedication'
 import TEXT06_TOC from '@/components/text/06_toc'
 import TEXT07_FORWARD from '@/components/text/07_forward'
 import TEXT08_PREFACE from '@/components/text/08_preface'
 import TEXT09_ACKNOWLEDGEMENT from '@/components/text/09_acknowledgement'
 import TEXT10_ABBREVIATIONS from '@/components/text/10_abbreviations'
 import TEXT11_CHAPTER1 from '@/components/text/11_chapter1'
 import TEXT12_CHAPTER2 from '@/components/text/12_chapter2'
 import TEXT13_CHAPTER3 from '@/components/text/13_chapter3'
 import TEXT14_CHAPTER4 from '@/components/text/14_chapter4'
 import TEXT15_CHAPTER5 from '@/components/text/15_chapter5'
 import TEXT16_CHAPTER6 from '@/components/text/16_chapter6'
 import TEXT17_CHAPTER7 from '@/components/text/17_chapter7'
 import TEXT18_CHAPTER8 from '@/components/text/18_chapter8'
 import TEXT19_CHAPTER9 from '@/components/text/19_chapter9'
 import TEXT20_CHAPTER10 from '@/components/text/20_chapter10'
 import TEXT21_CHAPTER11 from '@/components/text/21_chapter11'
 import TEXT22_CHAPTER12 from '@/components/text/22_chapter12'
 import TEXT23_CHAPTER13 from '@/components/text/23_chapter13'
 import TEXT24_CHAPTER14 from '@/components/text/24_chapter14'
 import TEXT25_CHAPTER15 from '@/components/text/25_chapter15'
 import TEXT26_APPENDIXA from '@/components/text/26_appendixA'
 import TEXT27_APPENDIXB from '@/components/text/27_appendixB'
 import TEXT28_APPENDIXC from '@/components/text/28_appendixC'
 import TEXT29_APPENDIXD from '@/components/text/29_appendixD'
 import TEXT30_APPENDIXE from '@/components/text/30_appendixE'
 import TEXT31_APPENDIXF from '@/components/text/31_appendixF'
 import TEXT32_BIBLIOGRAPHY from '@/components/text/32_bibliography'
 import TEXT33_INDEX from '@/components/text/33_index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/06_toc",
 			"name" : "text/06_toc",
 			"component" : TEXT06_TOC
 		},
 		{
 			"path" : "/text/07_forward",
 			"name" : "text/07_forward",
 			"component" : TEXT07_FORWARD
 		},
 		{
 			"path" : "/text/08_preface",
 			"name" : "text/08_preface",
 			"component" : TEXT08_PREFACE
 		},
 		{
 			"path" : "/text/09_acknowledgement",
 			"name" : "text/09_acknowledgement",
 			"component" : TEXT09_ACKNOWLEDGEMENT
 		},
 		{
 			"path" : "/text/10_abbreviations",
 			"name" : "text/10_abbreviations",
 			"component" : TEXT10_ABBREVIATIONS
 		},
 		{
 			"path" : "/text/11_chapter1",
 			"name" : "text/11_chapter1",
 			"component" : TEXT11_CHAPTER1
 		},
 		{
 			"path" : "/text/12_chapter2",
 			"name" : "text/12_chapter2",
 			"component" : TEXT12_CHAPTER2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js